import React from 'react';
import type { MultiLineTextQuestion as MultiLineTextQuestionType } from './survey.types';
import { useLanguageStore } from '../../stores/languageStore';
import LanguageHelper from '../../utils/languageHelper';

interface MultiLineTextQuestionProps {
  question: MultiLineTextQuestionType;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  displayNumber?: number;
}

export const MultiLineTextQuestion: React.FC<MultiLineTextQuestionProps> = ({
  question,
  value,
  onChange,
  error,
  displayNumber,
}) => {
  const languageCode = useLanguageStore((state) => state.code);

  return (
    <div className="survey-question multi-line-text-question">
      <label className="question-label">
        {displayNumber != null && (
          <span className="question-number">{displayNumber}.</span>
        )}
        <span dangerouslySetInnerHTML={{ __html: question.question_text[languageCode] }} />
        {question.is_required && <span className="required-indicator">*</span>}
      </label>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="text-area-input"
        rows={6}
        style={{ minHeight: '160px' }}
        placeholder={LanguageHelper.getExtendedTranslation(languageCode, 'enterYourResponse')}
      />
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};
